/**
 * Rounds column in scoring site
 * @param {object} player
 */
export default function RoundsColumn(player) {
  let template = "";
  let tdColumn = `<td class="text-center round-column">`;
  if (typeof HQ.Properties.currentRound === "undefined") {
    template += `
        ${tdColumn}</td>`;
  } else {
    for (let i = 0; i <= HQ.Properties.currentRound; i++) {
      const playerRounds = player["rounds"][i];
      if (playerRounds && i < HQ.Properties.currentRound) {
        template += `${tdColumn}${playerRounds["score"]}</td>`;
      } else if (playerRounds && i === HQ.Properties.currentRound) {
        template += `${tdColumn}${playerRounds["score"]}</td>`;
      }
    }
  }

  return template;
}
